import actionTypes from '../actions/privacy-policy.action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRIVACY_POLICY_SUCCESS:
      return [...action.content];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/reducers/privacy-policy-content.js